import { Type } from '@angular/core';
import { AutomateDataState } from 'src/app/modules/admin/profile-management/profile-detail/automate-datastate-log/automate-datastate-model';
import { Page } from 'src/app/shared/models/paging/page';
import { PagedData } from 'src/app/shared/models/paging/paged-data';
import { InquiryStageStat } from './inquiry-stage-stat.model';

/**
 * ## Proposal History Store State Model
 *
 * Canonical state shape managed by `CrmProposalHistoryWidgetStore`.
 * Keeps summary/list/lazy-component concerns in one feature-scoped snapshot.
 */
export interface CrmProposalHistoryWidgetState {
  total: number;
  stageStats: InquiryStageStat[];
  pageData: PagedData<any> | null;
  currentPage: Page | null;
  queryKey: string;
  summaryQueryKey: string;
  stageList: AutomateDataState[];
  summaryLoading: boolean;
  listLoading: boolean;
  lazyTableComponent: Type<any> | null;
  loadingLazyComponent: boolean;
  loadAll: boolean;
  gridMounting: boolean;
  gridMounted: boolean;
  gridLoadError: boolean;
}

// Backward-compatible alias for existing consumers.
export type CrmProposalHistoryWidgetData = CrmProposalHistoryWidgetState;

/** Creates a fresh initial state instance for this feature store. */
export function createInitialCrmProposalHistoryWidgetState(): CrmProposalHistoryWidgetState {
  return {
    total: 0,
    stageStats: [],
    pageData: null,
    currentPage: null,
    queryKey: '',
    summaryQueryKey: '',
    stageList: [],
    summaryLoading: false,
    listLoading: false,
    lazyTableComponent: null,
    loadingLazyComponent: false,
    loadAll: false,
    gridMounting: false,
    gridMounted: false,
    gridLoadError: false,
  };
}

// Backward-compatible factory name.
export const createEmptyCrmProposalHistoryWidgetData = createInitialCrmProposalHistoryWidgetState;
